export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.8.14-1508.41",
  commitId: "80707bf11f76b2d9a040243e1babffc1dbe6fa9b",
  commitTime: "2026-08-14T15:08:41.000Z",
});
